import React from 'react'
import { CatalogFilterFields } from '../../../../types/types'
import SwitchCheckbox from '../../../../Components/UI/SwitchCheckbox/SwitchCheckbox'
import { RouteComponentProps, withRouter } from 'react-router'
import { SetValuesFormik } from '../../../../types/formTypes'
import { resetFieldAfterRequired } from '../../utils/utils'

interface RequiredNowFieldProps extends RouteComponentProps {
    values: CatalogFilterFields
    setValues: SetValuesFormik<CatalogFilterFields>
}

const RequiredNowField: React.FC<RequiredNowFieldProps> = React.memo((props) => {

    const {
        values, location, history,
        setValues,
    } = props

    const handleChange = (value: boolean) => {
        resetFieldAfterRequired({
            setValues,
            values,
            newValues: {
                isRequiredNow: value,
            },
            history,
            location,
        })
    }

    return (
        <SwitchCheckbox
            text="Обязателен сейчас"
            checked={values.isRequiredNow}
            // classes={['bf-create-adaptive']}
            classes={['bf-create-requred-now']}
            onChange={e => handleChange(e?.target.checked || false)}
        />
    )
})

export default withRouter(RequiredNowField)